export const absoluteLoaderTheme = {
  bg: 'palette.transparent',
  firstLine: 'palette.primary.20',
  secondLine: 'palette.primary.20',
};
